import { Component } from "@odoo/owl";

class ProfilingSystrayItem extends Component {
    static template = "web.ProfilingSystrayItem";
    static props = {};
}

export const profilingSystrayItem = {
    Component: ProfilingSystrayItem,
};
